import "./Landing.scss";

function Hero(){
  return (
    <div class="hero_container">
      <div class="hero_text">
        <h1>Weekly Tree</h1>
        <p>Receive weekly email updates from your choice of LinkTree's, all in one email </p>
        <a href="#start" class="button">start receiving emails</a>
      </div>
      <div class="hero_image"></div>
    </div>
  )
}

export default Hero;